var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{attrs:{"label":_vm.$t('createTask'),"icon":['fal', 'plus']},on:{"click":function($event){return _vm.$bus.$emit('task', { reference: _vm.reference })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }